import { Badge, Input, Select, Space, Typography } from "antd";

const { Option } = Select;

export default function InstancesToolbar({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  moduleFilter,
  onModuleChange,
  moduleOptions = [],
  live = true,
}) {
  return (
    <div className="instances-toolbar">
      <Space>
        <Badge
          color={live ? "green" : "red"}
          text={live ? "Live updates" : "Offline"}
        />
        <Typography.Text type="secondary">WebSocket stream</Typography.Text>
      </Space>

      <Input.Search
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search containers, modules, ports..."
        allowClear
        style={{ minWidth: 240, flex: 1 }}
      />

      <Select
        value={statusFilter}
        onChange={onStatusChange}
        style={{ minWidth: 150 }}
      >
        <Option value="all">All statuses</Option>
        <Option value="RUNNING">Running</Option>
        <Option value="STOPPED">Stopped</Option>
      </Select>

      <Select
        value={moduleFilter}
        onChange={onModuleChange}
        style={{ minWidth: 180 }}
      >
        <Option value="all">All modules</Option>
        {moduleOptions.map((m) => (
          <Option key={m} value={m}>
            {m}
          </Option>
        ))}
      </Select>
    </div>
  );
}
